module.exports = __webpack_public_path__ + "assets/img/inner.002cb3a9.svg";